import type { FunctionComponent } from "react"

import Image from "next/image"

import { Card, CardBody, CardBodyHeader, CardCover, CardCoverImage, CardFooter } from "@jobteaser/spark/components/Card"
import { Heading } from "@jobteaser/spark/components/Heading/Heading"
import { Signature } from "@jobteaser/spark/components/Signature"
import { Text } from "@jobteaser/spark/components/Text/Text"

import styles from "./CardCompanyContentBoost.module.css"

export type CardCompanyContentBoostProps = {
  previewUrl: string
  title: string
  type: string
  company: {
    logoUrl: string
    name: string
  }
}

export const CardCompanyContentBoost: FunctionComponent<CardCompanyContentBoostProps> = ({
  previewUrl,
  title,
  type,
  company,
}) => {
  return (
    <Card className={styles.card}>
      {previewUrl && (
        <CardCover fullWidth>
          <CardCoverImage>
            <Image src={previewUrl} alt={title} fill />
          </CardCoverImage>
        </CardCover>
      )}

      <CardBody>
        <CardBodyHeader>
          <Text variant="body1">{type}</Text>
          <Heading variant="title3">{title}</Heading>
        </CardBodyHeader>
        <CardFooter className={styles.cardFooter}>
          <Signature
            avatar={<Image src={company.logoUrl} alt={company.name} width={24} height={24} />}
            label={company.name}
            size="small"
          />
        </CardFooter>
      </CardBody>
    </Card>
  )
}
